module.exports = __webpack_public_path__ + "img/facebook.78127303.svg";